import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../css/News.css";
import axios from "axios";
import StockChart from "../components/StockChart";
import { handleLogout } from "../utils/logout";
import { splitSummary } from "../utils/splitSummary";
import { handleSearch } from "../utils/search";
import { fetchSessionUser } from "../utils/userInfo";
import Footer from "./Footer";
import Header from "./Header";
import SockJS from "sockjs-client";
import { Stomp } from "@stomp/stompjs";
import AdLeft from "./AdLeft";
import AdRight from "./AdRight";

function News() {
  const navigate = useNavigate();
  const location = useLocation();
  const [profileBox, setProfileBox] = useState(false);
  const [urlInput, setUrlInput] = useState("");
  const [newsData, setNewsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState(0);
  const [statusText, setStatusText] = useState("분석을 시작합니다...");
  const [userInfo, setUserInfo] = useState(null);
  const [analysisId, setAnalysisId] = useState(null);

  const url = location.state?.url;
  const id = location.state?.id;

  // useEffect(() => {
  //   if (!url) return;

  //   // ✅ WebSocket 연결
  //   const stompClient = Stomp.over(() => new SockJS(`${process.env.REACT_APP_SPRING_API_URL}/analyze`));
  //   stompClient.reconnectDelay = 5000;

  //   stompClient.connect({}, () => {
  //     console.log("✅ WebSocket 연결 성공");

  //     // 진행률 및 상태 메시지 수신
  //     stompClient.subscribe("/topic/analyze-progress", (msg) => {
  //       const data = msg.body;

  //       if (!isNaN(data)) {
  //         setProgress(parseInt(data, 10));
  //       } else {
  //         setStatusText(data);
  //       }
  //     });

  //     // 최종 결과 수신
  //     stompClient.subscribe("/topic/analyze-complete", (msg) => {
  //       try {
  //         const result = JSON.parse(msg.body);
  //         console.log("분석 완료:", result);
  //         setNewsData(result);
  //       } catch (err) {
  //         console.error("결과 파싱 실패:", err);
  //       }
  //       setProgress(100);
  //       setLoading(false);
  //     });

  //     // 분석 요청 전송
  //     console.log("보내는 데이터:", { url, id });
  //     stompClient.send(
  //         "/app/analyze",
  //         { "content-type": "application/json" },
  //         JSON.stringify({ url: url, id: id })
  //     );
  //   });

  //   return () => {
  //     stompClient.disconnect(() => {
  //       console.log("🔌 WebSocket 연결 종료");
  //     });
  //   };
  // }, [url]);
  useEffect(() => {
    if (!url) return;

    let stompClient = null;
    let isCancelled = false;

    const connectWSAndSubscribe = (analysisId) =>
      new Promise((resolve, reject) => {
        stompClient = Stomp.over(
          () => new SockJS(`${process.env.REACT_APP_SPRING_API_URL}/analyze`),
        );
        stompClient.reconnectDelay = 5000;

        stompClient.connect(
          {},
          () => {
            console.log("✅ WebSocket 연결 성공", analysisId);

            // progress 구독
            stompClient.subscribe(
              `/topic/analyze-progress/${analysisId}`,
              (msg) => {
                try {
                  const data = JSON.parse(msg.body);
                  if (typeof data.percent === "number")
                    setProgress(data.percent);
                  if (data.message) setStatusText(data.message);
                } catch (e) {
                  const body = msg.body;
                  if (!isNaN(body)) setProgress(parseInt(body, 10));
                  else setStatusText(body);
                }
              },
            );

            // complete 구독
            stompClient.subscribe(
              `/topic/analyze-complete/${analysisId}`,
              (msg) => {
                try {
                  const body = msg.body;
                  const result = JSON.parse(body); // ✅ body는 거의 항상 string이니까 그냥 parse
                  if (result?.error) {
                    setStatusText(result.message || "분석 실패");
                    setLoading(false);
                    return;
                  }
                  setNewsData(result);
                  setProgress(100);
                  setLoading(false);
                } catch (err) {
                  console.error("결과 파싱 실패:", err, msg.body);
                  setStatusText("결과 파싱 실패");
                  setLoading(false);
                }
              },
            );

            resolve();
          },
          (err) => reject(err),
        );
      });

    const run = async () => {
      try {
        setLoading(true);
        setProgress(0);
        setStatusText("분석 요청 중...");

        // 1) 분석 요청 (analysisId 받기 + 캐시히트면 결과도 받기)
        const res = await axios.post(
          `${process.env.REACT_APP_SPRING_API_URL}/api/analyze-async`,
          { url, id: id ?? null },
        );

        const newAnalysisId = res.data?.analysisId;
        if (!newAnalysisId) throw new Error("analysisId가 없습니다.");
        if (isCancelled) return;

        setAnalysisId(newAnalysisId);

        // ✅ 캐시 히트면: WS 연결 없이 즉시 화면에 보여줌
        const cacheHit = res.data?.cacheHit;
        const cachedResult = res.data?.result;

        if (cacheHit && cachedResult) {
          console.log("⚡ cacheHit - WS 없이 즉시 렌더");
          setStatusText("✅ 기존 분석 결과를 불러왔습니다.");
          setNewsData(cachedResult);
          setProgress(100);
          setLoading(false);
          return;
        }

        // 2) 캐시 미스면 WS 연결 + 구독
        await connectWSAndSubscribe(newAnalysisId);
        // WS 놓쳤을 때 대비: 1초마다 최대 10번 결과 조회
        let tries = 0;
        const interval = setInterval(async () => {
          tries += 1;
          if (tries > 10 || isCancelled) {
            clearInterval(interval);
            return;
          }
          try {
            const r = await axios.get(
              `${process.env.REACT_APP_SPRING_API_URL}/api/analyze-result/${newAnalysisId}`,
            );
            if (r.data) {
              setNewsData(r.data);
              setProgress(100);
              setLoading(false);
              clearInterval(interval);
            }
          } catch (e) {
            // 404면 아직 준비중이니 무시
          }
        }, 1000);

        // (선택) WS가 연결되면 상태 문구 바꾸기
        setStatusText("분석 진행 중...");
      } catch (err) {
        console.error(err);
        setStatusText("⚠️ 분석 요청 실패");
        setLoading(false);
      }
    };

    run();

    return () => {
      isCancelled = true;
      if (stompClient) {
        stompClient.disconnect(() => console.log("🔌 WebSocket 연결 종료"));
      }
    };
  }, [url, id]);

  if (loading) {
    return (
      <div className="News-loading-container">
        <div className="News-loading-box">
          <p className="News-status-text">{statusText}</p>
          <div className="News-progress-bar">
            <div
              className="News-progress-fill"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <p className="News-progress-percent">{progress}%</p>
        </div>
      </div>
    );
  }

  if (!newsData) return <p>뉴스 정보를 가져오지 못했습니다.</p>;

  const classifyScore = (score) => {
    if (score >= 0.7) return "상";
    else if (score >= 0.5) return "중";
    else return "하";
  };

  const keywords = Array.isArray(newsData?.keywords || newsData?.keyword)
    ? newsData.keywords || newsData.keyword
    : [];

  const keywordList =
    keywords.length > 0
      ? keywords.map((item, idx) => (
          <li className="keyword-paragraph" key={idx}>
            {item?.word || item} -{" "}
            {item?.score ? classifyScore(item.score) : ""}
          </li>
        ))
      : [<li key="none">키워드 없음</li>];

  return (
    <div className="News">
      <Header />
      {/* 좌측 광고 */}
      <div className="AdLeft-container">
        <AdLeft />
      </div>
      {/* 우측 광고 */}
      <div className="AdRight-container">
        <AdRight />
      </div>
      <div className="News-img"></div>
      <header className="News-header">
        <div className="News-Search">
          <input
            id="News-search-input"
            placeholder="뉴스 URL을 입력하세요."
            value={urlInput}
            onChange={(e) => setUrlInput(e.target.value)}
            onFocus={(e) => e.target.select()}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch(urlInput, id, navigate); // ✅ 엔터로 검색 실행
              }
            }}
          />
          <img
            className="News-search-img"
            src="/icon.png"
            alt="돋보기"
            onClick={() => handleSearch(urlInput, id, navigate)}
          />
        </div>

        <div className="News-container">
          <div className="News-container-news">
            <a
              href={newsData.url}
              target="_blank"
              rel="noopener noreferrer"
              className="news-link"
            >
              <div className="News-news-img">
                {newsData.thumbnail_url ? (
                  <img
                    className="News-newsimg"
                    src={newsData.thumbnail_url}
                    alt="썸네일"
                  />
                ) : (
                  <img src="/default-thumbnail.png" alt="기본 썸네일" />
                )}
              </div>
            </a>
            <div className="News-news">
              <div className="News-news-title">
                <p>{newsData.title}</p>
              </div>
              <div className="News-news-detail">
                <p>{newsData.content}</p>
              </div>
              <div className="News-news-date">
                <p>{newsData.time}</p>
              </div>
            </div>
          </div>

          <div className="News-container-summation">
            <div className="News-summation-detail">
              <p className="summary-title">해당 뉴스의 요약</p>
              {newsData.summary &&
                splitSummary(newsData.summary).map((sentence, index) => (
                  <p className="summary-paragraph" key={index}>
                    {sentence}
                  </p>
                ))}
              <p className="summary-title">
                해당 뉴스의 키워드
                <br />
                <small style={{ color: "#888" }}>
                  유사도 상 (0.9% ~ 0.7%) 중 (0.7% ~ 0.5%) 하 (0.5% ~)
                </small>
              </p>
              <ul>{keywordList}</ul>
              <p className="summary-title">해당 뉴스의 관련된 회사</p>
              <p className="keyword-paragraph">{newsData.company}</p>

              <p className="summary-title">해당 뉴스의 감성분석</p>
              <p className="keyword-paragraph">{newsData.sentiment}</p>

              <p className="summary-title">해당 뉴스의 주가 예측</p>
              <p className="keyword-paragraph">
                해당 뉴스의 주가 예측으로 {newsData.prediction} (정확도{" "}
                {(newsData.prob * 100).toFixed(2)}%) 할 것 같습니다
              </p>
            </div>

            <div className="News-summation-chart">
              <StockChart companyName={newsData.company} />
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}

export default News;
